<template><div><h1>主题颜色配置</h1>
<h2>配置插件</h2>
<div class="warning">
<p>暂时只支持配合<code>vux-loader</code>使用。</p>
<p>注意的是主题文件不能引入其他less文件，只能为简单变量列表。</p>
</div>
<p>请配置vux-loader的<code>less-theme</code>插件，指定用以覆盖的less文件路径：</p>
<pre class="hljs"><code>{
  <span class="hljs-attr">name</span>: <span class="hljs-string">'less-theme'</span>,
  <span class="hljs-attr">path</span>: <span class="hljs-string">'src/styles/theme.less'</span> <span class="hljs-comment">// 相对项目根目录路径</span>
}
</code></pre>
<h2>可配置颜色</h2>
<p>源码地址：<a href="https://github.com/airyland/vux/blob/v2/src/styles/variable.less">https://github.com/airyland/vux/blob/v2/src/styles/variable.less</a></p>
<div class="tip">
<p>更多配置需求请通过 issue 提出。</p>
</div>
<h2>demo站点的示例配置</h2>
<p>源代码地址：<a href="https://github.com/airyland/vux/blob/v2/src/theme.less">https://github.com/airyland/vux/blob/v2/src/theme.less</a></p>
<h2>内部如何实现的？</h2>
<p><code>vux-loader</code> 在每个 <code>less</code> 文件的编译过程中重写了 <code>less-loader</code> 的变量参数，使其能直接覆盖原来变量。</p>
</div></template><script>
export default {
  head: {"title":"主题颜色配置 | VUX - Vue 移动端 UI 组件库","ignoreSuffixChar":"|"}
}
  </script>


// WEBPACK FOOTER //
// theme-280.vue?7365fa52